<template>
    <div class="index-warpper">
        <div class="index-mune margin-bottom">
            <h3 class="mune-title">系统菜单</h3>
            <div class="index-nav flex align-center flex-wrap margin-top-sm">
                <router-link v-if="payState === 1" class="margin-right-xs margin-bottom-sm"
                             to="/home/payment">
                    <img alt="" src="../../assets/img/nav_online_pay.png"/>
                </router-link>
                <div class="margin-right-sm margin-bottom-sm" @click="drawer = true">
                    <img alt="" src="../../assets/img/nav2.png"/>
                </div>
                <router-link v-if="user.user_info_state === 0" class="margin-right-sm margin-bottom-sm"
                             to="/home/info">
                    <img alt="" src="../../assets/img/nav3.png"/>
                </router-link>
                <router-link class="margin-right-sm margin-bottom-sm" to="/home/info2"
                ><img alt="" src="../../assets/img/nav8.png"
                /></router-link>
                <router-link
                    class="margin-right-sm margin-bottom-sm"
                    to="/home/certificate"
                ><img alt="" src="../../assets/img/chakanzhengshu.png"
                /></router-link>
                <router-link class="margin-right-sm margin-bottom-sm" to="/home/renew"
                ><img alt="" src="../../assets/img/nav1.png"
                /></router-link>


                <router-link v-if="user.user_info_state === 1" class="margin-right-sm margin-bottom-sm"
                             to="/home/infoup"
                ><img alt="" src="../../assets/img/biangengxinxi.png"
                /></router-link>

                <router-link class="margin-right-sm margin-bottom-sm" to="/home/notice"
                ><img alt="" src="../../assets/img/notice.png"
                /></router-link>
                <router-link class="margin-right-sm margin-bottom-sm" to="/home/account"
                ><img alt="" src="../../assets/img/nav5.png"
                /></router-link>
                <el-link class="margin-right-sm margin-bottom-sm" target="_blank" :underline="false" :href="showhost +'/static/file/new/北京消防协会会员信息系统（2.0版）使用手册-会员端.pdf'"
                ><img alt="" src="../../assets/img/nav10.png"
                /></el-link>
            </div>
        </div>
        <div class="index-mune margin-bottom">
            <h3 class="mune-title">会员说明</h3>
            <div class="explain">
                <p>
                    尊敬的会员，您好！欢迎加入北京消防协会。请认真阅读入会相关文件，准备好以下材料。
                </p>
                <p class="active">1、营业执照扫描件</p>
                <p class="active">2、承诺书扫描件（加盖公章并签字）</p>
                <p class="active2">
                    <el-link
                        :href="
              showhost +
              '/static/file/new/北京消防协会单位会员诚信服务承诺书（供给侧）.docx'
            "
                        :underline="false"
                        target="_blank"
                        type="primary"
                    >
                        （1）北京消防协会单位会员诚信服务承诺书（供给侧）
                    </el-link>
                </p>
                <p class="active2">
                    <el-link
                        :href="
              showhost +
              '/static/file/new/北京消防协会需求侧单位会员入会承诺书.docx'
            "
                        :underline="false"
                        target="_blank"
                        type="primary"
                    >
                        （2）北京消防协会需求侧单位会员入会承诺书
                    </el-link>
                </p>
                <p>联系人：会员部；联系电话：87095760。</p>
                <br/>
                <br/>
                <p>北京消防协会会员服务与管理有关文件</p>
                <p>
                    <el-link
                        :href="
              showhost +
              '/static/file/new/1、《北京消防协会会员服务管理办法》.pdf'
            "
                        :underline="false"
                        target="_blank"
                        type="primary"
                    >
                        1、《北京消防协会会员服务管理办法》
                    </el-link>
                </p>
                <p>
                    <el-link
                        :href="
              showhost +
              '/static/file/new/2、《北京消防协会会费收缴标准及管理办法》.pdf'
            "
                        :underline="false"
                        target="_blank"
                        type="primary"
                    >
                        2、《北京消防协会会费收缴标准及管理办法》
                    </el-link>
                </p>
                <p>
                    <el-link
                        :href="
              showhost +
              '/static/file/new/3、《北京消防协会单位会员十大服务项目实施细则（试行）》.pdf'
            "
                        :underline="false"
                        target="_blank"
                        type="primary"
                    >
                        3、《北京消防协会单位会员十大服务项目实施细则（试行）》
                    </el-link>
                </p>
                <p>
                    <el-link
                        :href="
              showhost +
              '/static/file/new/4、《单位会员信用等级评价办法（试行）》.docx'
            "
                        :underline="false"
                        target="_blank"
                        type="primary"
                    >
                        4、《单位会员信用等级评价办法（试行）》
                    </el-link>
                </p>
            </div>
        </div>
        <el-drawer :visible.sync="drawer" :with-header="false" title="">
            <div class="padding">
                <el-timeline>
                    <el-timeline-item
                        v-for="(item, index) in list"
                        :key="index"
                        :timestamp="item.create_time"
                        placement="top"
                    >
                        <el-card v-if="item.state === 1">
                            <h4>新申请提交成功，审核中</h4>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 2 || item.state === 8">
                            <h4>申请驳回</h4>
                            <br/>
                            <p style="color: #9a0000">驳回原因：{{ item.message }}</p>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 3 || item.state === 7">
                            <h4>{{ item.renew === 1 ? '续费申请' : '' }}信息提交成功，审核中</h4>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 4 || item.state === 10">
                            <h4>信息审核通过，待缴费</h4>
                            <br/>
                            <p style="color: #0d7fd7">
                                提示：请尽快缴纳会费，我们将于收到会费后，3个工作日内为您制作会员资信证书，请您耐心等待
                            </p>
                            <br/>
                            <el-radio-group v-model="checkPay">
                                <!--            TODO 在线缴费-->
                                <el-radio :label="1">在线缴费</el-radio>
                                <el-radio :label="3">对公缴费</el-radio>
                                <el-radio :label="6">线下缴费</el-radio>
                            </el-radio-group>

                            <p v-if="checkPay === 1" style="line-height: 200%">
                                微信缴费<br/>
                                <router-link v-if="payState === 1 && index === 0" class="margin-right-xs margin-bottom-sm"
                                             to="/home/payment">
                                    <el-button type="primary">立即缴费</el-button>
                                </router-link>
                            </p>
                            <p v-if="checkPay === 3" style="line-height: 200%">
                                转账(用途栏注明会费，个人账户请同时备注公司名称)<br/>
                                账户户名：北京消防协会<br/>
                                开户银行：中国工商银行北京新街口支行<br/>
                                银行账号：0200002909089213988
                            </p>
                            <p v-if="checkPay === 6" style="line-height: 200%">
                                现场缴费（微信、支付宝、银行卡、现金或支票）<br/>
                                地址：北京市朝阳区百子湾路16号金长安大厦A座802前台<br/>
                                电话：010-87095760
                            </p>

                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 5 || item.state === 11">
                            <h4>待领取</h4>
                            <br/>
                            <p style="color: #0d7fd7">
                                提示：您的单位会员资信证书已完成制作，请尽快领取
                            </p>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 6 || item.state === 12">
                            <h4>已领取</h4>
                            <br/>
                            <p style="color: #0d7fd7">提示：您已领取单位会员资信证书</p>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 9">
                            <h4>信息修改成功，审核通过</h4>
                            <br/>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {auditLog, getPayStatus} from "@/api/member";
import {SHOWHOST} from "@/config";

export default {
    name: "index",
    data() {
        return {
            drawer: false,
            list: [],
            //TODO 在线缴费-->
            checkPay: 1,
            payState: 0
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "会员首页  / ", false, 'icon-shouye');
        this.getAuditLog()
        this.getPayStatus()
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        showhost() {
            return SHOWHOST
        },
    },
    components: {},
    methods: {
        async getAuditLog() {
            let _list = await auditLog(this.user.id)
            this.list = _list.data
        },
        async getPayStatus() {
            let _data = await getPayStatus(this.user.id)
            this.payState = _data.data.pay_status
        }
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.index-warpper {
    .index-mune {
        padding: 30px 30px 10px;
        background-color: #ffffff;
        box-shadow: 0px 0px 21px 0px rgba(216, 231, 255, 0.54);
        border-radius: 8px;

        .mune-title {
            font-size: 20px;
            color: #0d7fd7;
            padding-left: 20px;
            position: relative;
            line-height: 24px;

            &:before {
                position: absolute;
                top: 0;
                left: 0;
                content: "";
                width: 10px;
                height: 24px;
                background-color: #0d7fd7;
                border-radius: 2px;
            }
        }

        .explain {
            padding: 20px;
            font-size: 16px;
            line-height: 30px;

            p {
                text-indent: 32px;

                &.active {
                    text-indent: 64px;
                }
            }
        }
    }
}
</style>